<template>
  <RegisterCollapseRow :title="$t('register.accountConfig.setPasswordTitle')" gap="gap-5">
    <el-form-item prop="password" :rules="passwordRules" class="custom-password-item">
      <el-input
        v-model="form.password"
        autocomplete="off"
        :placeholder="$t('openAccount.setPassword.placeholder')"
        @input="validatePassword"
        :disabled="disableField"
        :type="inputType"
        @focus="showPasswordTips = true"
        @blur="showPasswordTips = false"
      >
        <i slot="append" class="custome-icon" @click.stop="onChangeType">
          <img
            :src="
              inputType === 'password'
                ? require('@/assets/images/openAccount/eye_invisible_outlined.png')
                : require('@/assets/images/openAccount/eye_outlined.png')
            "
            alt=""
            :class="[inputType === 'password' ? 'input-password-icon' : 'input-text-icon']"
          />
        </i>
      </el-input>
      <div class="friendship-tips">{{ $t('openAccount.setPassword.friendshipTip') }}</div>
      <div class="password_tips_box" v-if="showPasswordTips">
        <div v-for="(item, index) in conditions" class="password_tips_item">
          <img
            class="tips_icon"
            :src="
              item.valid === true
                ? require('@/assets/images/openAccount/matchSuccess.png')
                : require('@/assets/images/openAccount/matchFailed.png')
            "
            alt=""
          />
          <div class="tips_text">{{ item.text }}</div>
        </div>
      </div>
    </el-form-item>
  </RegisterCollapseRow>
</template>

<script>
import RegisterCollapseRow from '../../RegisterCollapseRow.vue';
export default {
  name: 'OpenAccountSetPassword',
  components: {
    RegisterCollapseRow
  },
  props: {
    form: {
      type: Object,
      default: () => ({ password: '' })
    },
  },
  data() {
    return {
      passwordLength: 0,
      showPasswordTips: false,
      inputType: 'password',
      conditions: [
        { text: this.$t('openAccount.setPassword.lengthLimit'), valid: null },
        { text: this.$t('openAccount.setPassword.numberLimit'), valid: null },
        { text: this.$t('openAccount.setPassword.stringLimit'), valid: null },
        { text: this.$t('openAccount.setPassword.symbolLimit'), valid: null }
      ],
      passwordRules: [
        {
          validator: this.customPasswordValidator,
          message: this.$t('openAccount.setPassword.errorTip'),
          trigger: 'blur'
        }
      ]
    };
  },
  methods: {
    validatePassword() {
      this.showPasswordTips = true;
      const password = this.form.password || '';
      this.passwordLength = password.length;
      if (!password) {
        this.conditions.forEach(condition => (condition.valid = null));
      } else {
        this.conditions[0].valid = password.length >= 8 && password.length <= 15;
        this.conditions[1].valid = /[0-9]/.test(password);
        this.conditions[2].valid = /[A-Z]/.test(password) && /[a-z]/.test(password);
        this.conditions[3].valid = /[!@#$%^&*]/.test(password);
      }
    },
    customPasswordValidator(rule, value, callback) {
      const allValid = this.conditions.every(condition => condition.valid === true);
      if (!value) {
        return callback();
      } else if (allValid) {
        return callback();
      } else {
        return callback(new Error(this.$t('openAccount.setPassword.errorTip')));
      }
    },
    onChangeType() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-password-item {
  position: relative;
  width: 100%;
  .custom-icon {
    @include rtl-sass-prop(margin-right, margin-left, 20px);
  }
  .custom-icon {
    display: inline-block;
    height: 20px;
    line-height: 20px;
  }
  .friendship-tips {
    font-size: 12px;
    line-height: 17px;
    font-weight: 400;
    color: #6e6e73;
    margin-top: 12px;
  }

  .password_tips_box {
    position: absolute;
    z-index: 100;
    border-radius: 12px;
    padding: 12px;
    max-width: 450px;
    bottom: calc(100% + 10px);
    @include rtl-sass-prop(right, left, 30%);
    @media (max-width: $DEVICE_SIZE_LAPTOP) {
      @include rtl-sass-prop(right, left, 0);
    }
    background: #fff;
    box-shadow: 0px 4px 12px 0px #0000001a;
    .password_tips_item {
      display: flex;
      align-items: center;
      padding-bottom: 8px;
      &:last-child {
        padding-bottom: 0;
      }
      .tips_icon {
        width: 16px;
        height: 16px;
        @include rtl-sass-prop(margin-right, margin-left, 4px);
      }
      .tips_text {
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
        color: #1d1d1d;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
      }
    }
  }

  /deep/ .el-input__inner:focus {
    box-shadow: none;
  }

  /deep/ .el-input-group {
    border: 1px solid #eee;
    border-radius: 3px;
  }
  /deep/ .el-input-group__append {
    background-color: transparent;
    border: 0;
    width: 40px;
    margin: 0;
    padding: 0;
    text-align: center;
    img {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
  /deep/ .el-input-group--append .el-input__inner {
    border: 0;
    border-radius: 3px;
  }

  &.is-error /deep/ {
    .el-input__inner {
      border-color: none;
      border-bottom: 0px !important;
    }
    .el-input-group {
      border-color: #f44040;
    }
    .el-form-item__error {
      top: 40px;
    }
    .friendship-tips {
      margin-top: 30px;
    }
  }
  &.is-success /deep/ {
    .friendship-tips {
      margin-top: 12px;
    }
  }
}
</style>
